import { createSelector } from 'async-selector-kit'
import { ILogin } from './reducer'

const rootState = (state: ILogin) => state.login

export const getLoginForm = createSelector(
  rootState,
  (state) => state.loginForm
)

export const getIsModalOpen = createSelector(
  rootState,
  (state) => state.isModalOpen
)
